import { render } from "./addWork.vue?vue&type=template&id=10029096&scoped=true"
import script from "./addWork.vue?vue&type=script&lang=js"
export * from "./addWork.vue?vue&type=script&lang=js"

import "./addWork.vue?vue&type=style&index=0&id=10029096&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10029096"]])

export default __exports__